/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "context/AuthContext";
import { useTooltip } from "context/TooltipProvider";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { addInstruction } from "services/doubtfulService";
import { DoubtfulCase, InvestigationFile } from "types";
import { LoadingIcon } from "utils/constant";
import { errorHandlerOnForm } from "utils/helper";
import FileUpload from "./FileUpload";

const defaultValue: DoubtfulCase = {
  crime_registration_number: "",
  incident_registration_number: "",
  prosecutor_registration_number: "",
  requesting_prosecutor: "",
  requesting_prosecutor_user_id: "",
  requesting_prosecutor_admin_unit: "",
  instruction_description: "",
  requested_date: null,
  request_status: "Pending",
  investigation_file_id: null,
  draft_document: null,
  team_final_instruction_summary_attchement: null,
  team_resolution_summary_document: null,
  registrar_refernece_no_out: "",
  team_resolution_summary: "",
  team_resolution_summary_date: null,
  team_draft_summary: "",
  team_draft_date: null,
  requesting_office_admin_unit: "",
  requesting_office_org_unit: "",
  team_final_instruction_summary: "",
  team_final_instruction_date: null,
  registrar_refernece_out: "",
  giving_direction_office_admin_unit: "",
  giving_direction_office_org_unit: "",
  org_id: "",
  admin_unit_id: "",
};

interface DoubtfulRequestProps {
  file: InvestigationFile;
  onCancel: () => void;
}

const DoubtfulRequest: React.FC<DoubtfulRequestProps> = ({
  file,
  onCancel,
}) => {
  // const { state } = useLocation();
  const navigate = useNavigate();
  const { loginData } = useAuth();
  const { showTooltip } = useTooltip();
  const [loading, setLoading] = React.useState(false);

  const [formState, setFormState] = useState<DoubtfulCase>(defaultValue);

  useEffect(() => {
    if (file) {
      setFormState((prevState) => ({
        ...prevState,
        investigation_file_id: file?.id,
        crime_registration_number: file?.crime_reference_number,
        incident_registration_number: file?.incident_registration_number,
        admin_unit_id: loginData?.admin_unit?.toString() ?? "",
        org_id: loginData?.org_unit?.toString() ?? "",
      }));
    }
  }, [file]);

  useEffect(() => {
    if (loginData) {
      setFormState((prevState) => ({
        ...prevState,
        requesting_prosecutor: loginData?.full_name,
        requesting_prosecutor_user_id: loginData?.user_id?.toString() ?? "",
        requesting_prosecutor_admin_unit:
          loginData?.admin_unit?.toString() ?? "",
      }));
    }
  }, [loginData]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = () => {
    if (!formState.prosecutor_registration_number)
      return "Prosecutor Registration Number is Required.";
    else if (!formState.instruction_description)
      return "Instruction Description is Required.";
    else if (!formState.instruction_description_document)
      return "Instruction Description Document is Required.";
    return "";
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const error = validateForm();
    if (error) {
      showTooltip(error, "error");
      return;
    }

    setLoading(true);
    const formData: DoubtfulCase = {
      ...formState,
      request_status: "Pending",
    };
    addInstruction(formData)
      .then(() => {
        showTooltip("Successfully Submitted!", "success");
        onCancel();
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      });
  };

  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onCancel();
    }
  };

  const handleFile = (file: File | null, name: string) => {
    setFormState({ ...formState, [name]: file });
  };

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-[600px]">
        <h2 className="text-lg font-semibold text-gray-800">
          Doubtful Instruction
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="rounded-lg  mt-4 ">
            <div>
              <div>
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <div className="flex flex-col mt-4">
                    <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                      Prosecutor Registration Number
                    </label>
                    <input
                      type="text"
                      placeholder="#123456"
                      className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                      name="prosecutor_registration_number"
                      value={formState?.prosecutor_registration_number ?? ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="flex flex-col mt-4 w-full">
                    <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                      Requested Date
                    </label>
                    <input
                      type="date"
                      className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                      name="requested_date"
                      value={
                        formState?.requested_date
                          ? new Date(formState.requested_date)
                              .toISOString()
                              .split("T")[0]
                          : ""
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="flex flex-col mt-4">
                  <label className="text-sm text-[#747171] font-[inter] font-[400] mb-2">
                    Instruction Description
                  </label>
                  <textarea
                    placeholder="Description ..."
                    rows={4}
                    className="bg-[#F2F2F2] rounded-lg p-2 focus:outline-none focus:ring focus:ring-blue-300"
                    name="instruction_description"
                    value={formState?.instruction_description ?? ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="flex flex-col mt-4 w-full">
                  <FileUpload
                    label="Team Final Instruction Summary Attachment"
                    fileTypes="application/pdf,image/*"
                    info="Upload Team Final Instruction Summary Document"
                    required={true}
                    onChange={(file) =>
                      handleFile(file, "instruction_description_document")
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 flex justify-between gap-2">
            <button
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded w-full hover:bg-gray-300"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`border border-[#E90101] bg-[#E90101] px-10 py-2 text-white 
                        font-[Poppins] cursor-pointer font-[500] w-full
                        text-base rounded-md hover:bg-white hover:text-[#E90101]
                        ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  {LoadingIcon}
                  Loading...
                </div>
              ) : (
                "Create"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DoubtfulRequest;
